import React from "react"
import Connecting from "@modules/connection/Connecting"

const AppBootFallback = () => {
  return <Connecting />
}

export default AppBootFallback
